import { useEffect } from 'react';
import { useForm } from '@mantine/form';

import { useShowResponseStatus } from '@/shared';
import { useGetConfigSmsQuery, useUpdateConfigSmsMutation } from '../store/config-api';

import type { TConfigSms } from '../store/types';

type FormData = TConfigSms;

export const useConfigSms = () => {
  const {
    data,
    isLoading: isGetLoading,
    isSuccess: isGetSuccess,
    isError: isGetError,
  } = useGetConfigSmsQuery();

  const [updateSms, {
    isLoading: isUpdateLoading,
    isSuccess: isUpdateSuccess,
    isError: isUpdateError,
  }] = useUpdateConfigSmsMutation();

  const isLoading = isGetLoading || isUpdateLoading;
  const isSuccess = isUpdateSuccess;
  const isError = isGetError || isUpdateError;

  useShowResponseStatus({
    isSuccess,
    isError,
  });

  const form = useForm<FormData>({
    mode: 'uncontrolled',
    initialValues: {
      enabled: data?.enabled || false,
    },
  });

  useEffect(() => {
    if (isGetSuccess) {
      form.setValues({ ...data });
    }
  }, [isGetSuccess]);

  const handleSmsUpdate = async (params: TConfigSms) => {
    await updateSms(params);
  };

  const handleSubmit = (values: FormData) => {
    handleSmsUpdate(values);
  };

  return {
    // data,
    isLoading,
    form,
    // updateSms,
    // handleSmsUpdate,
    handleSubmit,
  };
};
